import React from 'react';
import ScheduleDayItem from './ScheduleDayItem';
import { AnyScheduleItem } from './types';

interface Props {
  name: string;
  firstHour: number;
  lastHour: number;
  items: Array<AnyScheduleItem>;
  pixelsPerHour: number;
  topOffsetPx: number;
  bottomOffsetPx: number;
}

const ScheduleDayColumn = (props: Props): React.ReactElement => {
  const {
    name,
    firstHour,
    lastHour,
    items,
    pixelsPerHour,
    topOffsetPx,
    bottomOffsetPx,
  } = props;

  const numHours = lastHour - firstHour;
  const height = numHours * pixelsPerHour + topOffsetPx + bottomOffsetPx;

  const calculateItemOffset = (item: AnyScheduleItem): number => {
    const offsetHour = item.hour + item.minute / 60 - firstHour;
    return offsetHour * pixelsPerHour + topOffsetPx;
  };
  const calculateItemHeight = (item: AnyScheduleItem): number =>
    (item.length / 60) * pixelsPerHour;

  const processedItems = items.map(item => {
    const top = calculateItemOffset(item);
    const height = calculateItemHeight(item);
    return {
      source: item,
      top,
      height,
      bottom: top + height,
      split: null as 'left' | 'right' | null,
    };
  });

  processedItems.forEach((item, index) => {
    const overlapping = processedItems.find((otherItem, otherIndex) => {
      if (otherIndex <= index) {
        return false;
      }

      // This works. Too tired to figure out how
      return !(
        item.bottom < otherItem.top + 1 || item.top + 1 > otherItem.bottom
      );
    });
    if (overlapping) {
      item.split = 'left';
      overlapping.split = 'right';
    }
  });

  return (
    <div className="column">
      <div className="column-label">{name}</div>
      <div className="column-content" style={{ height }}>
        {processedItems.map((item, index) => (
          <ScheduleDayItem
            key={index}
            pixelsPerHour={pixelsPerHour}
            offsetTop={item.top}
            height={item.height}
            item={item.source}
            split={item.split}
          />
        ))}
      </div>
    </div>
  );
};

export default ScheduleDayColumn;
